import { Link } from "react-router-dom";
import { LogOut, ExternalLink, UserCog } from "lucide-react";
import { LogoMark } from "@/components/site/Logo";
import { useAuth } from "@/context/AuthContext";

export const AdminShell = ({ title, eyebrow, actions, children }) => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#FAFAF7]" data-testid="admin-shell">
      <header className="sticky top-0 z-40 border-b border-black/10 bg-[#0B0B0B] text-white">
        <div className="mx-auto flex h-16 max-w-[1280px] items-center justify-between gap-4 px-5 md:px-8">
          <Link to="/admin" data-testid="admin-home-link" className="flex items-center gap-3">
            <LogoMark className="h-8 w-8" />
            <span className="font-wide whitespace-nowrap text-sm font-black">TIDE INCHEM <span className="hidden font-mono text-[11px] font-normal tracking-[0.2em] text-[#FFC400] sm:inline">ADMIN</span></span>
          </Link>
          <div className="flex items-center gap-2 sm:gap-4">
            <span className="hidden font-mono text-xs text-zinc-400 sm:inline">{user?.email}</span>
            <a href="/" target="_blank" rel="noreferrer" data-testid="admin-view-site" className="hidden items-center gap-1.5 font-mono text-xs uppercase tracking-[0.15em] text-zinc-300 hover:text-white sm:flex">
              <ExternalLink className="h-3.5 w-3.5" /> Site
            </a>
            <Link to="/admin/account" data-testid="admin-account-link" className="flex items-center gap-1.5 font-mono text-xs uppercase tracking-[0.15em] text-zinc-300 hover:text-white">
              <UserCog className="h-4 w-4" /> <span className="hidden sm:inline">Account</span>
            </Link>
            <button onClick={logout} data-testid="admin-logout-btn" className="flex items-center gap-2 whitespace-nowrap border border-white/20 px-3 py-2 font-mono text-xs uppercase tracking-[0.15em] hover:border-[#FF5A00] hover:text-[#FF5A00]">
              <LogOut className="h-3.5 w-3.5" /> Log out
            </button>
          </div>
        </div>
      </header>
      <div className="mx-auto max-w-[1280px] px-5 py-10 md:px-8 md:py-14">
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <div>
            <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-zinc-700"><span className="h-2 w-2 bg-[#FF5A00]" />{eyebrow}</p>
            <h1 data-testid="admin-page-title" className="font-wide mt-4 text-3xl font-black uppercase tracking-tight md:text-5xl">{title}</h1>
          </div>
          {actions}
        </div>
        <div className="mt-10">{children}</div>
      </div>
    </div>
  );
};
